@for (_ of Array.from({length: otpLength}); track $index; let i = $index) {
  <input pInputText
    class="p-inputotp-input"
    #digit
    type="tel" maxlength="1"
    [value]="otpDigits[i]"
    (keydown.backspace)="onBackspace(i)"
    (paste)="onPaste($event, i)"
    (input)="onKeyup($event, i)"
  />
}
